<template>
    <span :class="color_class"><li :class="icon"></li> {{ text }} </span>
</template>

<script>
    export default {
        name: "WarningIcon",
        props: {
            text: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                default: 'el-icon-question'
            },
            color_class: {
                type: String,
                default: 'text-warning'
            },
        }
    }
</script>

<style scoped>

</style>